import * as angular from "angular";
import {IController} from "angular";

export class RuleTimeInputComponent implements IController {
  timeStr: string;
  isRequired: boolean;
  onChange: Function;

  public timeModel: number;

  constructor(private moment) {}

  $onInit() {
    this._setTimeModel();
  }

  $onChanges(changes) {
    if (changes.timeStr && !changes.timeStr.isFirstChange()) {
      this._setTimeModel();
    }
  }

  onTimeSelect(date) {
    // Always format output as 24h (HH:mm) regardless of UI display
    const formattedTime = date ? this.moment(date).format('HH:mm') : undefined;
    this.onChange({time: formattedTime});
  }

  private _setTimeModel() {
    if (this.timeStr) {
      // Parse 24h input string into a timestamp for the picker
      this.timeModel = this.moment(this.timeStr, 'HH:mm').valueOf();
    } else {
      this.timeModel = undefined;
    }
  }
}

angular
  .module('bringoz.admin.ruleEngine')
  .component('ruleTimeInput', {
    bindings: {
      timeStr: '<',
      isRequired: '<',
      onChange: '&'
    },
    template: `
      <bringoz-time-select
        ticks-in-minutes="10"
        selected-time="$ctrl.timeModel"
        is-required="$ctrl.isRequired"
        on-select="$ctrl.onTimeSelect(date)">
      </bringoz-time-select>
    `,
    controller: RuleTimeInputComponent
  });
